import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import PlayerProvider from "@/context/PlayerContext";
import ProfileProvider from "@/context/ProfileContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import MiniPlayer from "@/components/MiniPlayer";
import Discover from "@/pages/Discover";
import Upload from "@/pages/Upload";
import CoachPage from "@/pages/Coach";
import LibraryPage from "@/pages/Library";
import StudioPage from "@/pages/Studio";
import Artist from "@/pages/Artist";
import { SignInPage, SignUpPage } from "@/pages/Auth";

export default function App() {
  return (
    <div className="App min-h-screen" style={{ position: "relative", zIndex: 2 }}>
      <BrowserRouter>
        <ClerkAuthProvider>
          <PlayerProvider>
           <ProfileProvider>
            <Header />
            <Routes>
              <Route path="/" element={<Discover />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/coach" element={<CoachPage />} />
              <Route path="/library" element={<LibraryPage />} />
              <Route path="/studio" element={<StudioPage />} />
              <Route path="/artist/:id" element={<Artist />} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
            </Routes>
            <MiniPlayer />
            <Toaster theme="dark" position="bottom-right" />
           </ProfileProvider>
          </PlayerProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}
